import React from 'react';

function SimpleSingleIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={19}
      height={44}
      viewBox="0 0 19 44"
      fill="none">
      <path
        d="M15.6629 6.80706C15.6629 10.0175 12.7457 12.62 10.0355 12.62C7.32539 12.62 4.4082 10.0175 4.4082 6.80706C4.4082 3.59659 6.9278 0.994141 10.0355 0.994141C13.1433 0.994141 15.6629 3.59659 15.6629 6.80706Z"
        fill="#FFC99C"
      />
      <path
        d="M11.6521 12.2031H8.32324V13.8758H11.6521V12.2031Z"
        fill="#FFC99C"
      />
      <path
        d="M10.0263 13.457H9.97215C5.76811 13.457 3.82959 15.636 3.43671 19.807L2.23455 29.1451L2.08398 30.2097V30.6687C2.08398 31.2388 2.55685 31.7002 3.12382 31.7002C3.69079 31.7002 4.16366 31.2388 4.16366 30.6687V29.9826H4.71416L5.38464 24.3471L5.66695 19.4143C5.66695 16.5752 7.15848 16.4593 9.98156 16.4593L10.0192 16.5871C12.8423 16.5871 14.3338 16.5066 14.3338 19.348L15.2866 29.9873H15.6066V30.6734C15.6066 31.2436 16.0794 31.7049 16.6464 31.7049C17.2134 31.7049 17.6862 31.2436 17.6862 30.6734V29.4763L16.2465 19.8378C16.2465 15.61 14.2327 13.4641 10.0286 13.4641L10.0263 13.457Z"
        fill="#FFC99C"
      />
      <path
        d="M6.10742 25.1738L6.67674 41.8366L8.40353 41.8177L9.94446 29.0515L11.5254 41.9076H13.2145L13.9015 25.1738H6.10742Z"
        fill="#CD232E"
      />
      <path
        d="M10.0265 15.8133C10.0265 15.8133 8.34444 13.5515 8.29739 13.5586C5.72838 13.9703 4.15216 15.572 3.67224 18.0845C3.56873 18.6286 2.2207 28.9367 2.2207 28.9367H4.89558L6.01775 20.3723L6.05069 27.1836L13.8918 27.2877L14.0894 20.5758L15.1787 28.9367H17.7594C17.7594 28.9367 16.3455 18.0325 16.1126 17.2896C15.4845 15.2975 14.0283 13.9442 11.8051 13.561L10.0265 15.8133Z"
        fill="#17385D"
      />
      <path
        d="M8.43888 41.75L8.5071 43.1624H4.4748C3.93371 43.1624 4.32424 42.7366 4.90532 42.4574C5.98515 41.9393 6.74268 41.7737 6.74268 41.7737L8.44123 41.75H8.43888Z"
        fill="#433934"
      />
      <path
        d="M11.5178 41.8567L11.4189 43.1603H15.623C16.1853 43.1603 15.7806 42.8078 15.176 42.5168C14.0515 41.9774 13.1787 41.8496 13.1787 41.8496L11.5178 41.8543V41.8567Z"
        fill="#433934"
      />
      <path
        d="M12.1483 0.487368C10.7438 0.0520493 8.67355 -0.378538 7.00557 0.955808C6.9844 0.612758 7.00087 0.241318 7.12085 0C7.12085 0 6.72797 0.584368 6.58447 1.261C6.49977 1.32015 6.39626 1.39586 6.28099 1.49286C5.59639 1.47157 4.94237 1.71288 4.94237 1.71288C5.20586 1.65374 5.57286 1.72944 5.90222 1.83354C5.07412 2.65213 4.03193 4.18994 4.40834 6.55343C4.40834 6.55343 6.67151 4.04326 7.01734 2.92657C7.01734 2.92657 15.456 6.30738 15.743 7.12597C15.743 7.12597 16.4135 1.80988 12.1483 0.485001V0.487368Z"
        fill="#AF6617"
      />
      <path
        opacity="0.4"
        d="M18.9975 43.2404C18.9975 43.6613 14.7442 44.0003 9.49875 44.0003C4.25331 44.0003 0 43.6591 0 43.2404C0 42.8217 4.25331 42.4805 9.49875 42.4805C14.7442 42.4805 18.9975 42.8217 18.9975 43.2404Z"
        fill="#BCB297"
      />
    </svg>
  );
}

export default SimpleSingleIcon;
